import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

/**
 * Platform mode separation
 * - construction: Construction Platform (subscription SaaS target)
 * - realEstate: Real Estate Services (separate experience)
 */
const PlatformModeContext = createContext(null);

const STORAGE_KEY = "platformMode";

function safeReadStoredMode() {
  try {
    const v = window.localStorage.getItem(STORAGE_KEY);
    if (v === "realEstate" || v === "construction") return v;
  } catch {
    // ignore
  }
  return "construction";
}

export function PlatformModeProvider({ children }) {
  const [mode, setModeState] = useState(() => safeReadStoredMode());

  const setMode = useCallback((nextMode) => {
    const m = nextMode === "realEstate" ? "realEstate" : "construction";
    setModeState(m);
    try {
      window.localStorage.setItem(STORAGE_KEY, m);
    } catch {
      // ignore
    }
  }, []);

  const value = useMemo(() => ({ mode, setMode }), [mode, setMode]);

  return <PlatformModeContext.Provider value={value}>{children}</PlatformModeContext.Provider>;
}

export function usePlatformMode() {
  const ctx = useContext(PlatformModeContext);
  if (!ctx) {
    throw new Error("usePlatformMode must be used within PlatformModeProvider");
  }
  return ctx;
}
